import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    emoji: '📘',
    title: 'TOMO 1 — Activación y Recuperación',
    desc: 'Volvé a moverte de forma segura y progresiva después del embarazo. Activá tu cuerpo sin forzarte y preparate para el cambio real.'
  }, {
    emoji: '📘',
    title: 'TOMO 2 — Entrenamientos desde Casa',
    desc: 'Rutinas cortas y efectivas que podés hacer en casa sin equipamiento. Ideales para entrenar incluso con poco tiempo.'
  }, {
    emoji: '📘',
    title: 'TOMO 3 — Alimentación Inteligente',
    desc: 'Aprendé a comer mejor sin dietas extremas ni restricciones. Bajá de peso de forma simple y sostenible.'
  }, {
    emoji: '📘',
    title: 'TOMO 4 — Abdomen y Suelo Pélvico',
    desc: 'Recuperá fuerza y firmeza en las zonas más afectadas. Entrená de forma segura y específica para tu cuerpo.'
  }, {
    emoji: '📘',
    title: 'TOMO 5 — Mentalidad y Constancia',
    desc: 'Dejá de empezar y abandonar todo el tiempo. Construí hábitos reales que puedas sostener.'
  }, {
    emoji: '📘',
    title: 'TOMO 6 — Transformación 90 Días',
    desc: 'Seguí un plan claro paso a paso durante 90 días. Lográ resultados reales sin complicarte.'
  }];
  const includes = ['Rutinas listas paso a paso', 'Sistema semanal armado', 'Opciones principiante/intermedio', 'Explicación simple de ejercicios', 'Mentalidad y motivación', 'Organización real para mamás', 'Seguimiento y progreso'];
  return <section className="py-6 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-314">
      <div className="text-center mb-6" data-id="element-315">
        <h2 className="font-display text-2xl md:text-4xl font-bold mb-2 flex items-center justify-center gap-2 text-gray-900" data-id="element-316">
          <span data-id="element-317">📘</span> 6 TOMOS COMPLETOS
        </h2>
        <div className="inline-block bg-pink-50 border border-pink-200 rounded-full px-4 py-1.5 mt-2" data-id="element-318">
          <p className="text-brand-accent font-semibold tracking-wide flex items-center gap-2 text-sm" data-id="element-319">
            <span data-id="element-320">🧩</span> SISTEMA PROGRESIVO REAL
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-id="element-321">
        {tomos.map((tomo, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.08
      }} className="bg-white border border-pink-200 rounded-2xl p-5 hover:border-pink-300 transition-colors group shadow-sm" data-id="element-322">
            <div className="text-3xl mb-2 group-hover:scale-110 transition-transform origin-left" data-id="element-323">
              {tomo.emoji}
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-1" data-id="element-324">
              {tomo.title}
            </h3>
            <p className="text-gray-500 text-sm leading-relaxed" data-id="element-325">{tomo.desc}</p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-white border border-pink-200 rounded-2xl p-6 md:p-8 max-w-4xl mx-auto shadow-sm" data-id="element-326">
        <h3 className="text-xl md:text-2xl font-bold mb-5 flex items-center gap-2 text-gray-900" data-id="element-327">
          <span data-id="element-328">💎</span> Cada tomo incluye:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-6" data-id="element-329">
          {includes.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-330">
              <CheckCircle2 className="text-brand-success flex-shrink-0 mt-0.5" size={18} data-id="element-331" />
              <span className="text-gray-700 text-base" data-id="element-332">{item}</span>
            </div>)}
        </div>
      </motion.div>
    </section>;
}